import React from "react";

type PasswordProps = {
  color?: string;
};

const Password: React.FC<PasswordProps> = ({ color = "black" }) => {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_15301_2347)">
        <path
          d="M2 17.364H22V19.364H2V17.364ZM3.15 13.314L4 11.834L4.85 13.314L6.15 12.564L5.3 11.084H7V9.58401H5.3L6.15 8.11401L4.85 7.36401L4 8.83401L3.15 7.36401L1.85 8.11401L2.7 9.58401H1V11.084H2.7L1.85 12.564L3.15 13.314ZM9.85 12.564L11.15 13.314L12 11.834L12.85 13.314L14.15 12.564L13.3 11.084H15V9.58401H13.3L14.15 8.11401L12.85 7.36401L12 8.83401L11.15 7.36401L9.85 8.11401L10.7 9.58401H9V11.084H10.7L9.85 12.564ZM23 9.58401H21.3L22.15 8.11401L20.85 7.36401L20 8.83401L19.15 7.36401L17.85 8.11401L18.7 9.58401H17V11.084H18.7L17.85 12.564L19.15 13.314L20 11.834L20.85 13.314L22.15 12.564L21.3 11.084H23V9.58401Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_15301_2347">
          <rect
            width="24"
            height="24"
            fill={color}
            transform="translate(0 0.36377)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Password;
